<template lang="html">
  	<div class="vipIn">
	    <common-header></common-header>
	    <vip-in></vip-in>
  	</div>
</template>

<script>
	import commonHeader from '../../components/common/commonHeader'
	import vipIn from '../../components/vipIn/vipIn'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		vipIn,
	  	},
	}
</script>

<style lang="less" scoped>
	.vipIn{
		padding-bottom:250px;
		
	}
</style>


// WEBPACK FOOTER //
// src/container/vipInPage/vipIn.vue